import React, { useState, useEffect } from "react";
import Datagrid from "@ui/components/DataGrid";
import SearchBar from "@ui/components/SearchBar";
import {
  buttonClassName,
  nexStepButtonStyle,
} from "../../../AddNewTest/constants";
import { useFetch } from "../../../../../hooks/fetch.hook";
import { linkTests } from "../_api";
import { renderTestsRow } from "../../Tests/helpers";
import { getTests } from "../../Tests/_api";

const HEADINGS = [
  ["code", "Test Code"],
  ["name", "Test Name"],
  ["status", "Status"],
];
const headerStyle = {
  background: "#E8F5E1",
  color: "#71BF44",
};

export const TestsList = ({
  data,
  handleClose,
  laboratoryId,
  setNonLinkedTests,
  setLoading,
  updateTestsList,
  setTestsList,
  linkedTests = [],
}) => {
  const { request } = useFetch();

  const [selected, setSelected] = useState({});
  const [initialData, setInitialData] = useState([]);

  useEffect(() => {
    setLoading(true);
    const arrayOfIds = linkedTests.map((item) => item.id);
    request(getTests)
      .then((tests) => {
        if (!tests) return;
        const data = tests.filter((item) => !arrayOfIds.includes(item.id));
        setNonLinkedTests(data);
        setInitialData(data);
        setTestsList(tests);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  const KEY_MAP = {
    "Test Code": data.map((item) => item.code),
    "Test Name": data.map((item) => item.name),
    Status: data.map((item) => item.status),
  };

  const handleSearch = (search, isRemoveKey) => {
    setNonLinkedTests(
      (isRemoveKey ? initialData : data).filter((item) => {
        const _search = Object.entries(search).map((item) => [
          HEADINGS.find((i) => i[1] === item[0])[0],
          item[1],
        ]);
        return (
          _search.length === 0 ||
          _search.every(([k, v]) => {
            if (Array.isArray(item[k])) {
              return item[k].includes(v);
            }
            return item[k] === v;
          })
        );
      })
    );
  };

  const handleSubmit = () => {
    setLoading(true);
    const payload = Object.keys(selected)
      .filter((item) => Boolean(selected[item]))
      .map((item) => ({
        id: item,
      }));
    request(linkTests, payload, laboratoryId).then((ids) => {
      if (!ids) return;
      updateTestsList();
      handleClose();
    });
  };

  const resetSearch = () => setNonLinkedTests(initialData);

  const selectedCount = Object.values(selected).filter(Boolean).length;

  return (
    <>
      <div className="bg-white rounded p-10">
        <h4 className="mb-6">
          <strong>Select Tests</strong>
        </h4>
        <div className="mb-10">
          <SearchBar
            onSearch={handleSearch}
            clearSearch={resetSearch}
            keyMap={KEY_MAP}
            placeholder="Filter Tests..."
            elevation={2}
            chipBackgroundColor="#E8F5E1"
            chipColor="#255915"
          />
        </div>
        <div className="border 1px solid #E5E5E5">
          <div
            className="d-flex justify-content-between p-5 align-items-center"
            style={headerStyle}
          >
            <h6>{`${
              selectedCount > 1
                ? `${selectedCount} items`
                : `${selectedCount} item`
            } selected`}</h6>
          </div>
          <Datagrid
            data={data}
            headings={HEADINGS}
            renderRow={renderTestsRow}
            selected={selected}
            setSelected={setSelected}
            selectable
          />
        </div>
        <div className="row mt-10">
          <div className="col-6 text-center">
            <button className={buttonClassName} onClick={handleClose}>
              Cancel
            </button>
          </div>
          <div className="col-6 text-center">
            <button
              className={nexStepButtonStyle}
              onClick={handleSubmit}
              disabled={!selectedCount}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
